import { Box, Button, Typography } from "@mui/material";
import { User, UserFormData } from "./user";
import { useAppDispatch, useAppSelector } from "../../store";
import { useEffect, useState } from "react";
import Modal from '@mui/material/Modal';
import PasswordField from "../../form/PasswordField";
import toast from "react-hot-toast";
import { updateUser } from "./userSlice";
import { enhancedApiClient, isSuccessResponse, ApiResponse } from "../../services/enhancedApiClient";
import { id } from "date-fns/locale";

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  mode: "create" | "edit";
  user: User | null;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  isOpen,
  onClose,
  mode,
  user,
}) => {
  const dispatch = useAppDispatch();
  // const selectedUser = useAppSelector(
  //   (state) => state.users.selectedUser
  // );
  
  // const [formData, setFormData] = useState({
  //   username:"",
  //   email: "",
  //   firstName: "",
  //   lastName: "",
  //   role: "worker" ,
  //   userType: "regular",
  //   status: true,
  //   phone: "",
  //   branchId:"",
  //   skills: [],
  //   password: "",
  //   confirmPassword: "",
  // });

  // only keep password fields for reset modal
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (!isOpen) {
      setFormData({ password: "", confirmPassword: "" });
    }
  }, [isOpen]);

  useEffect(()=>{
    console.log("ChangePasswordModal - user changed:", user);
  },[user]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.password || !formData.confirmPassword) {
      toast.error("Please fill in both fields");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const payload = { password: formData.password,confirmPassword: formData.confirmPassword  };
      console.log("ChangePasswordModal - submitting payload:", payload);
      const response = await enhancedApiClient.put(`users/${user?.id}/set-password`,payload)
      if (isSuccessResponse(response)) {
        console.log("password updated", response.data);
        toast.success("Password reset successfully!");
        setFormData({ password: "", confirmPassword: "" });
        onClose();
        return response.data;
      } 
      console.log("Failed update password", response);
      // Try to extract useful error message(s)
      const serverMessage =
        response?.error?.message ||
        response?.data?.message ||
        response?.data?.error?.message ||
        "Failed to update password";

      const detailMsg =
        response?.error?.details?.[0]?.msg ||
        response?.data?.error?.details?.[0]?.msg ||
        response?.data?.error?.details?.[0]?.message;

      toast.error(detailMsg || serverMessage);
    } catch (err) {
      console.error("ChangePasswordModal - submit error:", err);
      const message = err?.response?.data?.message || err?.message || "Failed to reset password";
      toast.error(message);
    } finally {
      // setLoading(false);
    }
  };

  return (
     <Modal open={isOpen} onClose={onClose}>
       <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2">
          Set new password
        </Typography>
        <Box sx={{mt:2, gap:2}}>
          <Box sx={{display:'flex', flexDirection:'column', gap:2}}>
          <PasswordField
            label="Password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            helperText="Password is required"
          />
          
          <PasswordField
            label="Confirm password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            helperText="Password is required"
          />
          </Box>
      </Box>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
          
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-indigo-500 dark:hover:bg-indigo-400"
          onClick={handleSubmit}
        >
          Reset Password
        </button>
      </div>
        
      </Box>
    </Modal>  
  )

}

export default ChangePasswordModal;

